export const AccountCount = ({ count }: { count: number }) => (
  <span className="rounded-full bg-blue-2 px-1.5 text-xs font-medium tabular-nums text-blue-7">
    {count}
  </span>
)
